<template>
  <v-content>
    <v-container @keyup.enter='login' class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-container>
                <v-toolbar-title>{{ 'Reset your Password' | translate }}</v-toolbar-title>
              </v-container>
              <v-spacer />
              <v-toolbar-items>
                <v-select
                  @change="changedLanguage"
                  :value="selectedLanguage"
                  :items="languages"
                  item-value="lang_code"
                  item-text="lang_name"
                  :label="'Language' | translate "
                  outlined
                  dense
                  class="pt-3"
                  style="width:140px;"
                ></v-select>
              </v-toolbar-items>


            </v-toolbar>
            <v-container>
              <v-card-text>
                  <template v-if="typeof errors === 'object' && Object.keys(errors).length >0">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">                        
                      <v-alert
                      dense
                      v-for="(v, k) in errors"
                      :key="k"
                      outlined
                      type="error"
                      >{{ k }} {{ v }}</v-alert>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-else-if="errors.length >0 ? true: false">
                    <v-row>
                      <v-col cols="12" sm="12" md="12"> 

                          <v-alert
                            dense
                            outlined
                            
                            type="error"
                          >{{ errors }}</v-alert>

                      </v-col>
                    </v-row>
                  </template >
                <v-alert dense outlined v-if="successmessage !== null" type="success">{{ successmessage | translate }}</v-alert>
                <v-form ref="form">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    :label="'Email' | translate"
                    name="email"
                    prepend-icon="email"
                    type="email"
                  >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>  
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" text @click="login">{{ 'Go to Login' | translate }}</v-btn>
                <v-spacer />
                <v-btn color="primary" @click="sendLink">{{ 'Send link' | translate }}</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import Vue from "vue";
import { RESET_STATE, LOGOUT,PAGES_RESET_STATE,STRIPE_RESET_STATE,FORGOT_PASSWORD } from "@/store/actions.type";
import {  PURGE_AUTH,SET_LOGGED_IN, SET_CUR_LANGUAGE,RESET_ALL_PAGES_DATA } from "@/store/mutations.type"
import store from "@/store";
import { mapState } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: "ForgotPassword",
  async beforeRouteEnter(to, from, next) {
    await store.commit(SET_LOGGED_IN, false)
    await store.dispatch(STRIPE_RESET_STATE)
    await store.commit(PURGE_AUTH)
    await  store.commit(RESET_ALL_PAGES_DATA),
    await store.dispatch(PAGES_RESET_STATE)
    await store.dispatch(RESET_STATE)
    await store.dispatch(LOGOUT)


    return next();
  }, 
  data() {
    return {
      valid: false,
      email: "",
      successmessage: null,
    };
  },
  methods: {
    sendLink: function() {
        this.successmessage = null
      if (this.$refs.form.validate()) {
          let email = this.email;
        this.$store
          .dispatch(FORGOT_PASSWORD, { email })
          .then(resp => {
              if(resp != undefined && resp.hasOwnProperty('success') && resp.success){
                  this.successmessage = resp.message
              }
          });
      }
    },
    login(){
        this.$router.push("/login")
    },
    async selLanguage(language) {
      await this.$store.commit(SET_CUR_LANGUAGE, language);
    },
    async changedLanguage(value) {
      Vue.i18n.set(value);
      let selectedLanguage = this.languages.find(x => value === x.lang_code);
      this.selLanguage(selectedLanguage)
    },  

  },
  computed: {
    ...mapGetters([
      'curLanguage'
    ]),   
    emailRules(){
      return [v => /.+@.+/.test(v) || "Invalid Email address"]
    },
    ...mapState({
      errors: state => state.auth.autherrors,
    }),
    languages(){
      let data = [{"lang_id":1,"lang_name": this.$t("English"),"lang_code":"en"},{"lang_id":2,"lang_name": this.$t("German"),"lang_code":"de"}]
      return data
    },
      selectedLanguage(){
        return this.curLanguage !== null ? this.curLanguage.lang_code : 'en'
      },
    isAuthenticated : function(){ return this.$store.getters.isAuthenticated}  
  },
  created(){
    this.changedLanguage(this.selectedLanguage)
    if(this.isAuthenticated){
      this.$router.push("/learningcenter")
    }    
  }
};
</script>
